const getters = {
  // Public: state => state.Public.Public,
}
export default getters;
